<div class="MainContainer">
  <div class="modalContent">
    <div class="d-flex flex-wrap">
      <div class="container">
        <div class="row">
          <div class="col-sm-5">
            <div class="leftContent">
              <app-contents [item]="CurrentItem"></app-contents>
            </div>
          </div>
          <div class="col-sm-7">
            <div class="formPanel">
              <div class="title">
                <!-- TODO New Changes for now  -->
                <h4> Login</h4>
                <p>Welcome back! Please log in to access your account.</p>
              </div>
              <div class="contentTab">
                <div class="form-content">
                  <!-- Form Section -->
                  <form [formGroup]="LoginForm" (ngSubmit)="onSubmit()">
                    <div class="form-group">
                      <label for="email" class="formLabel">Email<span class="req">*</span></label>
                      <input type="email" formControlName="email" tabindex="1" matInput directiveEmail
                        oninput="this.value = this.value.toLowerCase()" (keydown.space)="$event.preventDefault()"
                        class="form-control" [ngClass]="{'is-invalid': Submitted && LoginForm.get('email')?.errors }"
                        maxlength="100" tabIndex='0' />
                      <div *ngIf="Submitted && LoginForm.get('email')?.errors" class="invalid-feedback">
                        <div *ngIf="LoginForm.get('email')?.errors?.['required']">Email is required.</div>
                        <div *ngIf="LoginForm.get('email')?.errors?.['invalidEmail']">Please enter a valid email address.</div>
                      </div>
                    </div>
                    <div class="form-group">
                      <label for="password" class="formLabel">Password<span class="req">*</span></label>
                      <div class="position-relative">
                        <input [type]="showPassword ? 'text' : 'password'" formControlName="password" autocomplete="off"
                          minlength="6" class="form-control" id="password-field"
                          [ngClass]="{ 'is-invalid': Submitted && LoginForm.get('password')?.errors  }"
                          (keydown.space)="$event.preventDefault()" tabIndex='0' />
                        <mat-icon matSuffix class="eyeIcon" (click)="togglePasswordVisibility()">
                          {{showPassword?'visibility':'visibility_off'}}
                        </mat-icon>
                      </div>
                      <div *ngIf="Submitted && LoginForm.get('password')?.errors" class="invalid-feedbackP">
                        <div *ngIf="LoginForm.get('password')?.errors?.['required']">Password is required</div>
                        <div *ngIf="LoginForm.get('password')?.errors?.['minlength']">Password must be at least 6 characters</div>
                      </div>
                    </div>

                    <div class="bottomLink mb-3 d-flex flex-wrap">
                      <div class="custom-checkbox">
                        <input type="checkbox" class="form-control filled-in" formControlName="rememberme" value=""
                          id="chk_4" checked />
                        <label for="chk_4">Remember me</label>
                      </div>

                      <div class="ml-auto">
                        <a class="forgotLink" [routerLink]="['/auth/forgotpassword']">Forgot
                          Password?</a>
                      </div>
                    </div>
                    <div class="formButton d-flex align-items-center">
                      <button class="btn width30" class="btn btn-red">Login</button>
                      <div *ngIf="HeadingText == Users.Supplier" class="ml-auto"><a class="btn-link"
                          [routerLink]="['/supplier/register/']">Create
                          Account</a></div>
                    </div>
                    <!-- <h3 class="text-danger mt-2">{{LoginMsg}}</h3> -->
                  </form>
                  <!-- Form Section Close -->
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
</div>
